import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classNames from 'classnames';

function AppraiseByTabsHeaderItemBase({
  tabId,
  label,
  onBtnClick,
  isActive = false,
  isFirstItem = false,
  isAppraisalValuePage = false,
  isBackgroundStyleTabEnabled = false,
  renderAddressTab = false,
}) {
  const handleClick = useCallback(() => {
    onBtnClick(tabId);
  }, [onBtnClick, tabId]);

  const firstItemPaddingClass = isAppraisalValuePage
    ? {
        'px-0_5': !isFirstItem,
        'ps-0 pe-0_5': isFirstItem,
      }
    : {
        'px-0_5 px-md-0_75': !isFirstItem && !isBackgroundStyleTabEnabled,
        'ps-0 pe-0_5 pe-md-0_75': isFirstItem && !isBackgroundStyleTabEnabled,
        'pt-0_75': isBackgroundStyleTabEnabled,
        'px-1': isBackgroundStyleTabEnabled && !renderAddressTab,
        'px-0_75 px-sm-1_5 px-md-2': renderAddressTab,
        'pb-0': isActive && isBackgroundStyleTabEnabled,
      };

  const firstItemStyleClass = {
    'm-0': !isAppraisalValuePage && isBackgroundStyleTabEnabled,
    'rounded-start': !isAppraisalValuePage && isFirstItem && isBackgroundStyleTabEnabled,
  };

  return (
    <Button
      role="tab"
      color={isBackgroundStyleTabEnabled ? 'custom' : undefined}
      className={classNames(
        'appraise-by-tab-control size-16 pt-0 text-gray-darker text-decoration-none pb-0_5',
        `tab-${tabId.toLowerCase()}`,
        {
          active: isActive,
          'text-primary-darker': isActive && isBackgroundStyleTabEnabled,
          'bg-gray-lightest': !isActive && isBackgroundStyleTabEnabled,
          'border-0': !isBackgroundStyleTabEnabled,
          ...firstItemPaddingClass,
          ...firstItemStyleClass,
        }
      )}
      onClick={handleClick}
      data-testid={`tab-${tabId}`}
      data-tracking-id="appraisal_tab_selected"
      data-tracking-value={label}
      data-no-refresh
      aria-selected={isActive}
    >
      <span
        className={classNames('appraise-by-tab-label text-capitalize fw-normal', {
          'pb-0_5': isBackgroundStyleTabEnabled,
        })}
      >
        {label}
      </span>
    </Button>
  );
}

AppraiseByTabsHeaderItemBase.propTypes = {
  tabId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onBtnClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isFirstItem: PropTypes.bool,
  isAppraisalValuePage: PropTypes.bool,
  isBackgroundStyleTabEnabled: PropTypes.bool,
  renderAddressTab: PropTypes.bool,
};

export const AppraiseByTabsHeaderItem = memo(AppraiseByTabsHeaderItemBase);
